import styled, { css } from 'styled-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'
import { desktopBreakpoint } from 'react-components'

export const SliderContainer = styled.div(
    ({ theme }) => css`
        position: relative;
        max-width: 100%;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string }>`
    width: 100%;
    margin: ${({ margin }) => (!!margin ? margin : 0)};
    li {
        list-style: none;
    }
    touch-action: pan-y;
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        overflow: hidden;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        & .carousel__slider-tray.carousel__slider-tray--horizontal {
            margin: 0 -0.5rem;
            padding: 0.1rem 1rem;

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                padding: 0.1rem 0.1rem;
            }
        }

        .carousel__inner-slide {
            padding: 0 0.5rem;
            box-sizing: border-box;
        }
    `,
)
